<template>
    <div>
      <language-list></language-list>
    </div>
  </template>
  <script>
  export default {
  }
  </script>